import React from "react";
import { useTranslator } from "../../../hooks/useTranslator";

export const levelsEnglish = [
  {
    "description": {
      "es": "Comprende y usa algunas palabras y frases básicas para necesidades concretas, como saludos, despedidas y palabras clave sobre su entorno inmediato. Puede responder a preguntas muy sencillas sobre información personal, aunque depende del apoyo visual y de la repetición lenta.",
      "en": "Understand and uses basic words and phrases for concrete needs, such as greetings, farewells, and key terms related to the immediate environment. Can respond to very simple questions about personal information, though they rely on visual support and slow repetition."
    },
    "value": "Pre A1"
  },
  {
    "description": {
      "es": "Se comunica de manera muy básica usando frases y expresiones memorizadas sobre temas personales y cotidianos, como la familia y las rutinas. Puede responder a preguntas sencillas y expresar necesidades básicas si la otra persona habla despacio y claro.",
      "en": "Communicates very basic ideas using memorized phrases and expressions about personal and everyday topics, such as family and routines. Can respond to simple questions and express basic needs if the other person speaks slowly and clearly."
    },
    "value": "A1.1"
  },
  {
    "description": {
      "es": "Participa en intercambios simples sobre temas familiares, como hobbies y preferencias. Puede expresar gustos, rutinas y describir personas, siempre usando estructuras básicas y oraciones cortas, pero aún depende del apoyo de su interlocutor para comprender y responder.",
      "en": "Participates in simple exchanges about familiar topics, such as hobbies and preferences. Can express likes, routines, and describe people, always using basic structures and short sentences, but still depends on interlocutor support to understand and respond."
    },
    "value": "A1.2"
  },
  {
    "description": {
      "es": "Interactúa en situaciones sencillas, como pedir direcciones y hacer compras. Puede describir su entorno y actividades cotidianas en términos simples, así como expresar preferencias y reacciones emocionales básicas. Usa frases más detalladas y es capaz de pedir aclaraciones en una conversación.",
      "en": "Interacts in simple situations, such as asking for directions and shopping. Can describe their surroundings and daily activities in simple terms, as well as express preferences and basic emotional reactions. Uses more detailed phrases and can ask for clarifications during a conversation."
    },
    "value": "A2.1"
  },
  {
    "description": {
      "es": "Realiza intercambios sencillos y expresivos sobre temas cotidianos, como experiencias pasadas y planes futuros. Comprende y produce frases sobre temas de necesidad inmediata y personales, y es capaz de enlazar ideas sencillas para describir experiencias breves y actividades diarias.",
      "en": "Engages in simple and expressive exchanges on everyday topics, such as past experiences and future plans. Understands and produces phrases about immediate and personal needs and is able to link simple ideas to describe brief experiences and daily activities."
    },
    "value": "A2.2"
  },
  {
    "description": {
      "es": "Participa en discusiones informales en situaciones cotidianas y entiende el tema principal en conversaciones claras. Puede explicar y justificar brevemente opiniones o planes. Se expresa con suficiente claridad en conversaciones sobre temas conocidos, aunque con algunos errores en estructuras complejas.",
      "en": "Participates in informal discussions in everyday situations and understands the main topic in clear conversations. Can briefly explain and justify opinions or plans. Expresses themselves clearly enough in conversations about familiar topics, although errors appear in complex structures."
    },
    "value": "B1.1"
  },
  {
    "description": {
      "es": "Mantiene conversaciones de cierta extensión sobre temas familiares. Puede exponer opiniones y justificar puntos de vista en situaciones predecibles, y maneja información más detallada en narraciones sencillas. Su discurso es mayormente claro y fluido, con pausas para planificar y corregir errores.",
      "en": "Maintains somewhat extended conversations on familiar topics. Can present opinions and justify viewpoints in predictable situations and handles more detailed information in simple narratives. Speech is mostly clear and fluent, with pauses for planning and correcting errors."
    },
    "value": "B1.2"
  },
  {
    "description": {
      "es": "Demuestra habilidad para interactuar con fluidez en una variedad de temas, incluso en discusiones formales o académicas. Es capaz de desarrollar argumentos, expresar y defender opiniones, y responder a puntos de vista opuestos. Usa un rango más amplio de estructuras gramaticales, aunque aún presenta errores ocasionales.",
      "en": "Demonstrates the ability to interact fluently on a variety of topics, including formal or academic discussions. Can develop arguments, express and defend opinions, and respond to opposing views. Uses a wider range of grammatical structures, though occasional errors persist."
    },
    "value": "B2.1"
  },
  {
    "description": {
      "es": "Se comunica de manera efectiva y espontánea, con una buena comprensión de expresiones idiomáticas y complejas. Presenta opiniones bien estructuradas y es capaz de argumentar de manera persuasiva. Controla un discurso claro y detallado en temas complejos, y organiza sus ideas de forma coherente y lógica.",
      "en": "Communicates effectively and spontaneously, with a good understanding of idiomatic and complex expressions. Presents well-structured opinions and can argue persuasively. Maintains clear and detailed speech on complex topics, organizing ideas coherently and logically."
    },
    "value": "B2.2"
  },
  {
    "description": {
      "es": "Se expresa de manera fluida, precisa y espontánea en temas variados, incluso en temas abstractos o técnicos. Utiliza un amplio rango de vocabulario y estructuras complejas con poca necesidad de pausar para planificar. Es capaz de adaptar su estilo y registro al contexto, mostrando matices y sutilezas en el idioma.",
      "en": "Expresses themselves fluently, precisely, and spontaneously on varied topics, including abstract or technical ones. Utilizes a wide range of vocabulary and complex structures with little need for planning. Can adapt style and register to the context, showing nuances and subtleties in the language."
    },
    "value": "C1"
  },
  {
    "description": {
      "es": "Muestra un dominio total del idioma con un control preciso y natural sobre las expresiones idiomáticas, matices y registros lingüísticos. Puede manejar situaciones comunicativas complejas con facilidad, ajustando su discurso a cualquier contexto y mostrando una gran precisión y espontaneidad en sus respuestas.",
      "en": "Demonstrates complete mastery of the language, with precise and natural control over idiomatic expressions, nuances, and linguistic registers. Handles complex communicative situations with ease, adjusting speech to any context and showing great precision and spontaneity in responses."
    },
    "value": "C2"
  }
];

export const getDescription = (value, translate) => {
  return translate(value?.description)
}

export const getDescriptionByKey = (value, lang) => {
  if(lang === "es") return value?.description?.es;
  return value?.description?.en;
}

export const LevelsEnglishViewer = ({ value, description }) => {
  const { traslate } = useTranslator();
  return (
    <p className="p-0 m-0">
      <strong>{value}</strong>: {getDescription({ description }, traslate)}
    </p>
  );
}